import { useEffect, useState } from 'react';
import { Logo } from './Logo';

export function SplashScreen({ onComplete }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Show splash for 1.5 seconds then fade out
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Wait for fade animation to complete
      setTimeout(() => {
        onComplete();
      }, 300);
    }, 1500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 bg-primary flex items-center justify-center z-50 transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="text-center">
        {/* Logo */}
        <div className="mb-6 flex justify-center">
          <Logo className="w-32 h-32 drop-shadow-lg" color="#FFFFFF" />
        </div>
        
        {/* App Name */}
        <h1 className="text-5xl font-bold text-white mb-2" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          MealPlan Genie
        </h1>
        
        {/* Tagline */}
        <p className="text-xl text-white/90">Your weekly meal planning magic</p>
        
        {/* Loading indicator */}
        <div className="mt-8 flex justify-center">
          <div className="w-2 h-2 bg-white rounded-full animate-bounce mx-1" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce mx-1" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce mx-1" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}